<template>
  <div class="pulse-page">
    <img class="page-bg" :src="bgImage" alt="bg" />
    <!-- Logo -->
    <img class="page-logo" :src="logoImage" alt="Logo"/>

    <!-- 返回按钮 -->
    <img class="page-back-btn" @click="handleBack" :src="backButtonImage" alt="返回"/>

    <div class="content-box">
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <template v-else>
        <template v-if="viewData">
          <div class="service-section pulse-section">
           <div class="baige">
            <div class="bodyMass-title">脉诊结果
              <!-- <div class="bodyMass-div"></div> -->
            </div>

            <div class="rate-row">
              <img class="rate-icon" :src="rateIcon" alt="rate" />
              <div class="rate-text">
                <span class="rate-label">脉率：</span>
                <span class="rate-value">{{ viewData.pulseRate || '--' }}</span>
                <span class="rate-unit">次/分</span>
              </div>
            </div>

            <!-- 左手数据和图表暂时隐藏
            <div class="hand-card">
              <div class="hand-inner">
                <div class="hand-img-wrap">
                  <img class="hand-img" :src="handLeftImage" alt="left hand" />
                </div>

                <div class="chart-box">
                  <div class="hand-tag center">左手脉象</div>

                  <div class="level-dots">
                    <div class="dot dot-f">浮</div>
                    <div class="dot dot-m">中</div>
                    <div class="dot dot-d">沉</div>
                  </div>

                  <div ref="leftChartEl" class="chart" />
                </div>
              </div>
            </div>
            -->

            <div class="hand-card">
              <div class="hand-inner reverse">
                <div class="chart-box">
                  <div class="hand-tag left">右手脉象</div>

                  <div class="level-dots">
                    <div class="dot dot-f">浮</div>
                    <div class="dot dot-m">中</div>
                    <div class="dot dot-d">沉</div>
                  </div>

                  <div ref="rightChartEl" class="chart" />
                </div>

                <div class="hand-img-wrap">
                  <img class="hand-img" :src="handRightImage" alt="right hand" />
                </div>
              </div>
            </div>
           </div>  
          </div>

          <div class="service-section result-section">
           <div class="baige">
            <div class="bodyMass-title">结果倾向
              <!-- <div class="bodyMass-div"></div> -->
            </div>
            <div class="section-label">您的脉诊结果偏向为：</div>
            <div class="prob-card" v-if="viewData.pulseProbList && viewData.pulseProbList.length">
              <div
                  class="prob-header"
                  :style="{ '--cols': `repeat(${viewData.pulseProbList.length}, 1fr)` }"
              >
                <div v-for="item in viewData.pulseProbList" :key="item.name" class="th">
                  {{ item.name }}
                </div>
              </div>

              <div
                  class="prob-body"
                  :style="{ '--cols': `repeat(${viewData.pulseProbList.length}, 1fr)` }"
              >
                <div
                    v-for="item in viewData.pulseProbList"
                    :key="item.name"
                    class="td"
                    :class="{ hot: item.name === viewData.mainPulseType }"
                >
                  {{ item.value }}%
                </div>
              </div>
            </div>

            <div class="prob-card" v-else>
              <div class="prob-body" style="grid-template-columns: 1fr;">
                <div class="td" style="text-align: center;">暂无结果数据</div>
              </div>
            </div>
           </div>  
          </div>

          <div class="service-section desc-section">
           <div class="baige">
            <div class="bodyMass-title">脉象说明
              <!-- <div class="bodyMass-div"></div> -->
            </div>
            <div class="desc-card">
              <div class="desc-title-new"> 【{{ getHighestPulseName() }}】</div>
              <div class="desc-text" v-if="viewData.description">
                {{ viewData.description }}
              </div>
              <div class="desc-empty" v-else>暂无说明</div>
            </div>
           </div>  
          </div>

          <div class="service-section tip-section">
           <div class="baige">
            <div class="bodyMass-title">温馨提示
              <!-- <div class="bodyMass-div"></div> -->
            </div>
            <div class="tip-card">
              <div class="desc-title">温馨提示:</div>
              <div class="tip-text">
                脉象相似度以9%以上作为可参考结果。有些脉象波形与证侯相似(如弦，滑，实等)，请用户多测几次，以次数多的为参考结果，参考结果不能用作临床诊断，详情点击查看我司免责声明。脉象、证侯解释与养生建议等说明可用手机截图在相册里放大观看。
              </div>
            </div>
           </div>  
          </div>
        </template>

        <div v-else class="empty-state">暂无数据</div>
      </template>

      <div class="bottom-spacer"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as echarts from 'echarts'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PulseDiagnosis',
  data() {
    return {
      loading: false,
      leftChart: null,
      rightChart: null,

      bgImage: '/images/backgrounds/home-bg.png',
      logoImage: '/images/backgrounds/title4.png',
      backButtonImage: '/images/home/header-back@1x.png',

      rateIcon: '/images/pulse/rate.png',
      handLeftImage: '/images/pulse/left-hand.png',
      handRightImage: '/images/pulse/right-hand.png'
    }
  },
  computed: {
    ...mapGetters('report', ['pulseData']),
    /**
     * ✅ 视图适配层：把接口返回的 pulseData（response.data）转换成页面可直接渲染的数据结构
     * 映射约定：
     * fu/zhong/chen 分别表示 浮/中/沉
     */
    viewData() {
      if (!this.pulseData) return null

      const d = this.pulseData
      const safeArr = (v) => (Array.isArray(v) ? v : [])
      const mapHand = (m) => ({
        fu: safeArr(m && m.fu), // 浮
        zhong: safeArr(m && m.zhong), // 中
        chen: safeArr(m && m.chen) // 沉
      })

      let pr = {}
      try {
        pr = typeof d.pulseResult === 'string' ? JSON.parse(d.pulseResult) : (d.pulseResult || {})
      } catch (e) {
        pr = {}
      }

      const leftRate = Number(d.leftPulseRate)
      const rightRate = Number(d.rightPulseRate)
      const avgRate =
          Number.isFinite(leftRate) && Number.isFinite(rightRate)
              ? Math.round((leftRate + rightRate) / 2)
              : (Number.isFinite(leftRate) ? Math.round(leftRate) : (Number.isFinite(rightRate) ? Math.round(rightRate) : null))

      const clinical = Array.isArray(d.clinicalFeatures) ? d.clinicalFeatures : []
      const description = [d.pulseCharacter || '', clinical.length ? `\n\n【临床意义】\n${clinical.join('\n')}` : '']
          .join('')
          .trim()

      // ✅ prob-card 动态数据源：接口 pulseResult 的 key/value 转成数组以便 v-for
      const pulseProbList = Object.keys(pr).map((k) => ({
        name: k,
        value: Number(pr[k]) || 0
      }))

      return {
        pulseRate: avgRate,
        leftHand: mapHand(d.leftMap),
        rightHand: mapHand(d.rightMap),

        mainPulseType: d.mainPulseType || '',
        pulseProbList,

        description
      }
    }
  },
  async created() {
    this.loading = true
    const userId = this.$route.query.userId
    if (!userId) {
      this.loading = false
      return
    }

    try {
      await this.fetchPulseData({ userId })
    } catch (error) {
      console.error('Failed to load pulse data:', error)
    } finally {
      // ✅ 关键：先让页面从 loading 态切到内容态，DOM 才会渲染出 refs
      this.loading = false
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.disposeCharts()
  },
  watch: {
    // ✅ loading 结束后再 init（保证 v-else 分支已渲染，refs 一定存在）
    loading(val) {
      if (val === false) {
        this.$nextTick(() => this.initChartsIfReady(true))
      }
    },
    // ✅ 数据变化后在非 loading 状态重新渲染图表
    viewData: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('[PulseDiagnosis] viewData changed:', val)
        if (this.loading) return
        this.$nextTick(() => this.initChartsIfReady(true))
      }
    }
  },
  methods: {
    ...mapActions('report', ['fetchPulseData']),
    getHighestPulseName() {
      if (!this.viewData || !this.viewData.pulseProbList || !this.viewData.pulseProbList.length) {
        return '脉象'
      }
      
      // 找出概率最高的脉象类型
      let maxProb = -Infinity
      let maxName = '脉象'
      
      this.viewData.pulseProbList.forEach(item => {
        if (item.value > maxProb) {
          maxProb = item.value
          maxName = item.name
        }
      })
      
      return maxName
    },
    handleBack() {
      this.$router.back()
    },
    handleResize() {
      this.leftChart && this.leftChart.resize()
      this.rightChart && this.rightChart.resize()
    },
    disposeCharts() {
      if (this.leftChart) {
        this.leftChart.dispose()
        this.leftChart = null
      }
      if (this.rightChart) {
        this.rightChart.dispose()
        this.rightChart = null
      }
    },
    initChartsIfReady(forceRecreate = false) {
      if (!this.viewData) {
        console.warn('[PulseDiagnosis] initChartsIfReady stop: viewData is null')
        return
      }

      const hasLeft = !!this.$refs.leftChartEl
      const hasRight = !!this.$refs.rightChartEl

      // 如果两个都还没渲染出来，继续重试；只要其中一个存在，就可以继续初始化对应的图表
      if (!hasLeft && !hasRight) {
        console.warn('[PulseDiagnosis] initChartsIfReady stop: no chart refs yet, retry...')
        setTimeout(() => this.initChartsIfReady(forceRecreate), 50)
        return
      }

      const leftRect = hasLeft ? this.$refs.leftChartEl.getBoundingClientRect() : { width: 0, height: 0 }
      const rightRect = hasRight ? this.$refs.rightChartEl.getBoundingClientRect() : { width: 0, height: 0 }
      console.log('[PulseDiagnosis] chart container rect:', { leftRect, rightRect })

      // 如果某个存在的容器尺寸为 0，则延迟重试；不存在的容器直接忽略
      if ((hasLeft && (!leftRect.width || !leftRect.height)) ||
          (hasRight && (!rightRect.width || !rightRect.height))) {
        console.warn('[PulseDiagnosis] container size is 0, delay init...')
        setTimeout(() => this.initChartsIfReady(forceRecreate), 60)
        return
      }

      if (forceRecreate) this.disposeCharts()

      if (hasLeft && !this.leftChart) {
        this.leftChart = echarts.init(this.$refs.leftChartEl)
      }
      if (hasRight && !this.rightChart) {
        this.rightChart = echarts.init(this.$refs.rightChartEl)
      }

      if (hasLeft) {
        this.leftChart.setOption(this.createPulseChartOption(this.viewData.leftHand), true)
        this.leftChart.resize()
      }
      if (hasRight) {
        this.rightChart.setOption(this.createPulseChartOption(this.viewData.rightHand), true)
        this.rightChart.resize()
      }

      console.log('[PulseDiagnosis] charts rendered')
    },
    createPulseChartOption(handData) {
      const fu = handData && Array.isArray(handData.fu) ? handData.fu : []
      const zhong = handData && Array.isArray(handData.zhong) ? handData.zhong : []
      const chen = handData && Array.isArray(handData.chen) ? handData.chen : []

      const maxLen = Math.max(fu.length, zhong.length, chen.length, 30)
      const x = Array.from({ length: maxLen }, (_, i) => i)

      const mk = (data, color) => ({
        type: 'line',
        data,
        showSymbol: false,
        smooth: true,
        lineStyle: { width: 2, color }
      })

      return {
        animation: false,
        grid: { left: 10, right: 10, top: 14, bottom: 10, containLabel: false },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: x,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          splitLine: { lineStyle: { color: 'rgba(0,0,0,0.06)' } }
        },
        series: [mk(fu, '#2F6BFF'), mk(zhong, '#5AC86E'), mk(chen, '#F0B35A')]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pulse-page {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

.page-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

// Logo
.page-logo {
  position: absolute;
  left: 40rpx;
  top: 50rpx;
  width: 315.6rpx;
  height: 100rpx;
  z-index: 2;
}

// 返回按钮
.page-back-btn {
  position: absolute;
  left: 495rpx;
  top: 65rpx;
  width: 220rpx;
  height: 70rpx;
  border-radius: 10rpx;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6rpx;
  box-sizing: border-box;
  border: 1px solid #FFFFFF;
}
.content-box {
  position: absolute;
  left: 36rpx;
  top: 154rpx;
  width: 677rpx;
  z-index: 1;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80rpx 40rpx;
  min-height: 400rpx;

  .loading-spinner {
    width: 80rpx;
    height: 80rpx;
    border: 8rpx solid #f3f3f3;
    border-top: 8rpx solid #0e6eb8;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-text {
    margin-top: 32rpx;
    font-size: 28rpx;
    color: #666;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.service-section {
  position: relative;
  margin-top: 31.25rpx;
  width: 677rpx;
  border-radius: 20rpx;
  padding: 6rpx;
  box-sizing: border-box;
  background: rgba(175, 225, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 2px 10px 0px rgba(42, 150, 225, 0.3);
  z-index: 2;
}

.section-title {
  position: relative;
  width: 177rpx;
  height: 46.875rpx;
  border-radius: 26rpx 26rpx 26rpx 0;
  text-align: center;
  line-height: 46.875rpx;
  font-size: 26rpx;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(284deg, #2397f0 22%, #94de30 99%);
}

.desc-title-new{
    font-size: 22rpx;
  color: #3D3D3D;
  // font-weight: 800;
}

.rate-row {
  position: relative;
  left: 46.875rpx;
  margin-top: 24rpx;
  display: flex;
  align-items: center;
  gap: 12rpx;
}

.rate-icon {
  width: 32rpx;
  height: 32rpx;
}

.rate-text {
  font-size: 24rpx;
  color: #0e6eb8;
  letter-spacing: 1rpx;
}

.rate-label { color: #ff4d4f; font-weight: 600; }
.rate-value { color: #0e6eb8; font-weight: 700; }
.rate-unit { color: #0e6eb8; margin-left: 6rpx; }

.hand-card {
  position: relative;
  left: 46.875rpx;
  margin-top: 20rpx;
  width: 583rpx;
  border-radius: 18rpx;
  background: #ffffff;
  border: 2rpx solid rgba(37, 124, 255, 0.22);
  padding: 18rpx;
  box-sizing: border-box;
}

.hand-inner {
  display: flex;
  align-items: center;
  gap: 18rpx;
}

.hand-inner.reverse {
  flex-direction: row;
}

.hand-img-wrap {
  width: 200rpx;
  height: 310rpx;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hand-img {
  width: 200rpx;
  height: 310rpx;
  object-fit: contain;
}

.chart-box {
  position: relative;
  flex: 1;
  height: 310rpx;
  border-radius: 14rpx;
  background: #ffffff;
}

.hand-tag {
  position: absolute;
  top: 8rpx;
  height: 40rpx;
  line-height: 40rpx;
  padding: 0 18rpx;
  border-radius: 6rpx;
  font-size: 22rpx;
  color: #fff;
  background: #1e66ff;
  z-index: 2;
}
.hand-tag.center { left: 50%; transform: translateX(-50%); }
.hand-tag.left { left: 10rpx; transform: none; }

.level-dots {
  position: absolute;
  left: 0;
  top: 78rpx;
  width: 44rpx;
  display: flex;
  flex-direction: column;
  gap: 20rpx;
  z-index: 2;
}

.dot {
  width: 40rpx;
  height: 40rpx;
  border-radius: 20rpx;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20rpx;
  color: #fff;
}
.dot-f { background: #ff6b6b; }
.dot-m { background: #ff4d4f; }
.dot-d { background: #ff2d2f; }

.chart {
  position: absolute;
  left: 54rpx;
  top: 56rpx;
  right: 0;
  bottom: 0;
}

.section-label {
  position: relative;
  left: 46.875rpx;
  margin-top: 26rpx;
  font-size: 24rpx;
  color: #3d3d3d;
}

.prob-card {
  position: relative;
  left: 35.875rpx;
  margin-top: 14rpx;
  width: 583rpx;
  border-radius: 10rpx;
  overflow: hidden;
  border: 2rpx solid rgba(14, 110, 184, 0.18);
  background: #fff;
}

.prob-header,
.prob-body {
  /* flex fallback for very old WebView (Android 7.1 and earlier) */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  /* use grid when available; autoprefixer will add vendor prefixes */
  display: -ms-grid;
  display: -webkit-grid;
  display: grid;
  grid-template-columns: var(--cols);
}

.prob-header {
  background: #0e6eb8;
  color: #fff;
  font-size: 22rpx;
  height: 56rpx;
  align-items: center;
}

.prob-body {
  background: #fff;
  font-size: 22rpx;
  color: #3d3d3d;
  height: 56rpx;
  align-items: center;
}

.th, .td { text-align: center; flex: 1; min-width: 0; }
.td.hot { color: #ff4d4f; font-weight: 700; }

.desc-card,
.tip-card {
  position: relative;
  left: 35.875rpx;
  margin-top: 40rpx;
  width: 583rpx;
  border-radius: 12rpx;
  background: #f8f8f8;
  padding: 18rpx;
  box-sizing: border-box;
}

.desc-title{
  font-size: 20rpx;
  color: #3D3D3D;
  font-weight: 800;
}

.desc-text {
  font-size: 22rpx;
  line-height: 1.7;
  color: #3d3d3d;
  white-space: pre-wrap;
}

.desc-empty {
  font-size: 22rpx;
  color: #999;
}

.tip-text {
  font-size: 22rpx;
  color: #666;
  line-height: 1.6;
}

.empty-state {
  padding: 120rpx 0;
  text-align: center;
  font-size: 28rpx;
  color: #999;
}

.bottom-spacer {
  height: 60rpx;
}
.bodyMass-title {
  position: relative;
  left: 18.7rpx;
  top: 18.7rpx;    
  // height: 52px;
  opacity: 1;
  font-family: Source Han Sans;
  font-size: 33.6rpx;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  z-index: 6;
}

.bodyMass-div{
  position: absolute;
  left: 0px;
  top: 30.7rpx;
width: 140rpx;
height: 9.34rpx;
z-index: -1;
/* 主色 */
background: linear-gradient(270deg, #3D8AFE 0%, #5CC0FF 100%);
	
}
.baige{
  width: 654rpx;
  background-color: #fff;
  border-radius: 20rpx;
  padding-bottom: 30rpx;
}
</style>
